import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

interface resetPasswordState {
	response: string | null;
	resetPasswordLoading: boolean;
	resetPasswordError: string | null;
}

const initialState: resetPasswordState = {
	response: null,
	resetPasswordLoading: false,
	resetPasswordError: null
}

export const resetPassword = createAsyncThunk(
	'auth/resetPassword',
	async (credentials: any, { rejectWithValue }) => {
		try {
			const response = await axios.post('auth/resetPassword', credentials.data, {
				headers: { Authorization: `Bearer ${credentials.token}` }
			})
			return response.data;
		} catch (resetPasswordError: any) {
			return rejectWithValue(resetPasswordError.response.data || 'An error occured');
		}
	}
);

const resetPasswordSlice = createSlice({
	name: 'resetPassword',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		//user resetpassword reducers
		builder.addCase(resetPassword.pending, (state) => {
			state.resetPasswordLoading = true;
			state.resetPasswordError = null;
		});
		builder.addCase(resetPassword.fulfilled, (state, action) => {
			state.response = action.payload;
			state.resetPasswordLoading = false;
			state.resetPasswordError = null;
		});
		builder.addCase(resetPassword.rejected, (state, action) => {
			state.resetPasswordLoading = false;
			state.resetPasswordError = action.payload as string;
		});

	}
});

export const { reset } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
